import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "rebass";

import {audioCancel, audioSetVoice } from "../../../store/modules/audio/actions";
import { getIsPaused, getSelectedVoice, getVoices } from "../../../store/modules/audio/selectors";
import { Select, IOption } from "../Select";

export const VoiceControl: React.FC = () => {
  const dispatch = useDispatch();
  const voices = useSelector(getVoices);
  const isPaused = useSelector(getIsPaused);
  const selectedVoice = useSelector(getSelectedVoice);
  const options = useMemo(() => (
    voices.map<IOption>(({ abbr, name }) => ({
      label: abbr,
      value: name,
    }))
  ), [voices]);

  const handleChange = useCallback((value: string) => {
    dispatch(audioCancel(isPaused));
    dispatch(audioSetVoice(value));
  }, [isPaused, dispatch]);

  return (
    <Card border="1px solid #ededed" borderRadius="5px">
      <Select
        value={selectedVoice}
        options={options}
        menuPlacement="top"
        handleOnChange={handleChange}
      />
    </Card>
  );
};
